import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';

const MotionNavLink = motion(forwardRef((props, ref) => <NavLink ref={ref} {...props} />));

export default MotionNavLink;
